export default __webpack_public_path__ + "assets/background-images-2025.b59c9c12.jpg";